import { useThrottleEffect } from 'ahooks';
import { getLang } from 'lowcomp/plugins/member/utils';
import React, { useEffect } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PointsBehaviorValue } from '../config';
import { TextLang } from '../TextLang';
import css from './index.module.scss';
import SubscribeModal from './SubscribeModal';
import { usePoints } from './usePoints';
import { useGlobal } from '@/utils/useGlobal';
import { getUserPointsByActions } from '@/service/vip';
import { isMembersFestival } from '@/utils/membersFestival';
import { hasReferralLocale } from '@/constants/appreciationDay';
// import {
//     ReferralIcon,
//     RightFacebook,
//     RightFollow,
//     RightIcon,
//     RightIns,
//     RightKakoo,
//     RightX,
//     RightYoutube,
//     WaysEarnIcon,
//     WaysProfileIcon,
//     WaysRedeemIcon,
//     WaysSignUpIcon,
//     WaysWarrantyIcon,
// } from '@/components/UI/svg/Ecocredits/WaysIcons';
import {
    WaysSignUpIcon,
    WaysEarnIcon,
    WaysShopIcon,
    WaysWarrantyIcon,
    WaysProfileIcon,
    WaysInvitedIcon,
    RightIcon,
    RightIns,
    RightX,
    RightYoutube,
    RightFacebook,
    RightFollow,
    RightKakoo,
    RightCommunityPost,
    RightCommunityComment,
    RightCommunityLike,
} from '@/components/UI/svg/Ecocredits/WaysIconsNew';
import { getIsPadWidth } from '@elem/utils/devices';
import { EFQuestionMark2 } from '@/components/UI/svg/Ecocredits';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import { message } from '@/components/UI/Message';
import { signupCookie } from '@/utils/cookies/signupCookie';
import gtm from '@/utils/gtm';
import LoginFormModal from '@/components/LoginFormModal';
import { createPortal } from 'react-dom';

const FORUM_DOMAIN = process.env.NEXT_PUBLIC_FORUM_DOMAIN;

interface props {
    isLogin: boolean;
    rewardEarnRule: any[];
    refershData: () => void;
    data: any;
}

const WaysToEarnPoints: React.FC<props> = ({ isLogin, rewardEarnRule, refershData, data }) => {
    const { Link, useRouter, useState, isMobile, subEmailCount } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const t = getLang(TextLang, locale);
    const { inBlackList } = useEcoStore();

    const newWayType = 'wayType';
    const pageId = 'WAYS_TO_EARN_POINTS';

    const [profileModalOpen, setProfileModalOpen] = useState(false);
    const [subscribeModalOpen, setSubscribeModalOpen] = useState(false);
    const [swiper, setSwiper] = useState({});
    const [num, setNum] = useState(0);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showLoginModal1, setShowLoginModal1] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [isPadWidth, setIsPadWidth] = useState(false);

    const birthdayRule = rewardEarnRule.find((rule) => rule.source2 === 'ACCOUNT_INFO_BIRTHDAY');
    const birthdayIsFinish = !birthdayRule || birthdayRule?.isFinish === 1;
    const profileIsFinish = rewardEarnRule?.filter((rule) => rule.source === 'ACCOUNT_INFO')?.every((rule) => rule?.isFinish === 1);
    const subscribeRule = rewardEarnRule.find((rule) => rule.source2 === 'EDM');
    const subscribeIsFinish = !subscribeRule || subscribeRule?.isFinish === 1;
    const warrantyRule = rewardEarnRule.find((rule) => rule.source2 === 'WARRANTY');
    const warrantyIsFinish = !warrantyRule || warrantyRule?.isFinish === 1;
    const instagramRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_INSTAGRAM');
    const instagramIsFinish = !instagramRule || instagramRule?.isFinish === 1;
    const xRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_X');
    const xIsFinish = !xRule || xRule?.isFinish === 1;
    const tiktokRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_TITTOK');
    const tiktokIsFinish = !tiktokRule || tiktokRule?.isFinish === 1;
    const youtubeRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_YOUTUBE');
    const youtubeIsFinish = !youtubeRule || youtubeRule?.isFinish === 1;
    const facebookRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_FACEBOOK');
    const facebookIsFinish = !facebookRule || facebookRule?.isFinish === 1;
    const lineRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_LINE');
    const lineIsFinish = !lineRule || lineRule?.isFinish === 1;
    const kakooRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_KAKOO');
    const kakooIsFinish = !kakooRule || kakooRule?.isFinish === 1;
    const jFackbookRule = rewardEarnRule.find((rule) => rule.source2 === 'JOIN_FACEBOOK');
    const jFackbookIsFinish = !jFackbookRule || jFackbookRule?.isFinish === 1;
    const jKakooRule = rewardEarnRule.find((rule) => rule.source2 === 'JOIN_KAKOO');
    const jKakooIsFinish = !jKakooRule || jKakooRule?.isFinish === 1;
    const communityPostRule = rewardEarnRule.find((rule) => rule.source2 === 'COMMUNITY_SEND_CONTENT');
    const communityPostIsFinish = !communityPostRule || communityPostRule?.isFinish === 1;
    const communityCommentRule = rewardEarnRule.find((rule) => rule.source2 === 'COMMUNITY_SEND_COMMENT');
    const communityCommentIsFinish = !communityCommentRule || communityCommentRule?.isFinish === 1;
    const communityLikeRule = rewardEarnRule.find((rule) => rule.source2 === 'COMMUNITY_UPVOTE');
    const communityLikeIsFinish = !communityLikeRule || communityLikeRule?.isFinish === 1;
    const mfStatus = isMembersFestival(locale);
    console.log('mgStatus', mfStatus);

    const statusMap: Record<string, boolean> = !isLogin
        ? {
              sign_up: false,
              birthday: false,
              profile: false,
              subscribe: false,
              warranty: false,
              ATTENTION_INSTAGRAM: false,
              ATTENTION_X: false,
              ATTENTION_TITTOK: false,
              ATTENTION_YOUTUBE: false,
              ATTENTION_FACEBOOK: false,
              ATTENTION_LINE: false,
              ATTENTION_KAKOO: false,
              JOIN_FACEBOOK: false,
              JOIN_KAKOO: false,
              COMMUNITY_SEND_CONTENT: false,
              COMMUNITY_SEND_COMMENT: false,
              COMMUNITY_UPVOTE: false,
          }
        : {
              sign_up: true,
              birthday: birthdayIsFinish,
              profile: profileIsFinish,
              subscribe: subscribeIsFinish,
              warranty: warrantyIsFinish,
              ATTENTION_INSTAGRAM: instagramIsFinish,
              ATTENTION_X: xIsFinish,
              ATTENTION_TITTOK: tiktokIsFinish,
              ATTENTION_YOUTUBE: youtubeIsFinish,
              ATTENTION_FACEBOOK: facebookIsFinish,
              ATTENTION_LINE: lineIsFinish,
              ATTENTION_KAKOO: kakooIsFinish,
              JOIN_FACEBOOK: jFackbookIsFinish,
              JOIN_KAKOO: jKakooIsFinish,
              COMMUNITY_SEND_CONTENT: communityPostIsFinish,
              COMMUNITY_SEND_COMMENT: communityCommentIsFinish,
              COMMUNITY_UPVOTE: communityLikeIsFinish,
          };

    const addQueryParam = (type: string) => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        url.searchParams.set(newWayType, type);
        url.hash = pageId;
        return url;
    };

    const removeQueryParam = () => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        url.searchParams.delete(newWayType);
        window.history.replaceState({}, '', url);
    };

    // 每一个元素的状态（即hover展示的内容）由 登陆状态 & statusMap共同决定
    const defaultData = [
        {
            // 未登陆 / 已登陆
            key: 'sign_up',
            title: t('sign_up'),
            text: mfStatus === 0 ? t('sign_up_desc_h_1') : t('sign_up_desc_h'),
            highlighttext: mfStatus === 0 ? t('sign_up1_1') : t('sign_up1'),
            icon: <WaysSignUpIcon />,
            uncomplate: {
                desc: t('subscribe_hover'),
                button: t('sign_up'),
                onClick: () => {
                    signupCookie?.({
                        sector_name: t('earn_points_title'),
                        entry_position: 5,
                    });
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'signup_start',
                        entry_type: 'section entry',
                        entry_position: t('earn_points_title'),
                        entry_name: t('sign_up_desc_h'),
                        source_channel: 'Website',
                    });

                    console.log('--------');
                    console.log({ data });

                    if (data.loginType === 'modal') {
                        setShowLoginModal1(true);
                    } else {
                        router.push(`/register?redirect=${encodeURIComponent(window.location.href)}`);
                    }
                },
            },
        },
        {
            // 未登陆 / 未完成 / 已完成
            key: 'subscribe',
            title: t('subscribe'),
            text: t('subscribe_text'),
            highlighttext: t('subscribe1'),
            icon: <WaysEarnIcon />,
            uncomplate: {
                desc: t('subscribe_hover'),
                button: t('subscribe_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('subscribe_text')}_${t('subscribe_capital_letters')}`,
                        });
                        const newUrl = addQueryParam('subscribe');

                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        setSubscribeModalOpen(true);
                    }
                },
            },
        },
        {
            // 未登陆 / 已登陆
            key: 'shop',
            title: t('shop_capital_letters'),
            text: t('earn_point_by_order'),
            highlighttext: t('shop1'),
            icon: <WaysShopIcon />,
            uncomplate: {
                desc: t('earn_point_rule_shop'),
                button: t('shop_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('earn_point_by_order')}_${t('shop_capital_letters')}`,
                        });
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(`/${locale}/`)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('earn_point_by_order')}_${t('shop_capital_letters')}`,
                            url: `/${locale}`,
                        });
                        router.push(`/${locale}`);
                    }
                },
            },
        },
        {
            // 未登陆 / 已登陆
            key: 'warranty',
            title: t('warranty_capital_letters'),
            text: t('warranty_desc1'),
            highlighttext: t('warranty1'),
            icon: <WaysWarrantyIcon />,
            uncomplate: {
                desc: t('warranty1'),
                button: t('warranty_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('warranty_desc1')}_${t('warranty_capital_letters')}`,
                        });
                        const newUrl = addQueryParam('warranty');
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('warranty_desc1')}_${t('warranty_capital_letters')}`,
                            url: `/${locale}/support/warranty`,
                        });
                        if (inBlackList) return message.error(t('not_eligible'));
                        router.push(`/${locale}/support/warranty`);
                    }
                },
            },
        },
        {
            // 未登陆 / 未完成 / 已完成
            key: 'profile',
            title: t('profile'),
            text: t('profile_desc1'),
            highlighttext: t('profile1'),
            icon: <WaysProfileIcon />,
            uncomplate: {
                desc: t('profile_desc2'),
                learn_more: t('learn_more'),
                button: t('profile'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('profile_desc1')}_${t('profile')}`,
                        });
                        const newUrl = addQueryParam('profile');
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('profile_desc1')}_${t('profile')}`,
                            url: `/${locale}/my-overview`,
                        });
                        router.push(`/${locale}/my-overview`);
                    }
                },
            },
        },
    ];

    if (hasReferralLocale.includes(locale)) {
        defaultData.push({
            key: 'referral',
            title: t('referral'),
            text: t('referral_desc'),
            highlighttext: t('referral1'),
            icon: <WaysInvitedIcon />,
            uncomplate: {
                desc: t('referral_desc'),
                button: t('referral'),
                onClick: () => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'jump_button',
                        position: 'Inpage',
                        button_name: `${t('referral_desc')}_${t('referral')}`,
                        url: `/${locale}/referral`,
                    });
                    router.push(`/${locale}/referral`);
                },
            },
        });
    }

    const dataForSlide = (data: any) => {
        const pageSize = isPadWidth ? 3 : 6;

        const chunks = [];
        for (let i = 0; i < data.length; i += pageSize) {
            const chunk = data.slice(i, i + pageSize);
            chunks.push(chunk);
        }
        return chunks;
    };

    const [slideData, setSlideData] = useState(dataForSlide(defaultData));
    const { actionPoints, fetchPointtCards } = usePoints(locale);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        console.log({ slideData });
    }, [slideData]);

    const pollingData = () => {
        const delayTimer = [3, 5];
        delayTimer.forEach((timer) => {
            setTimeout(() => {
                refershData && refershData();
            }, timer * 1000);
        });
    };

    const getPoints = async (source: string) => {
        return await getUserPointsByActions({ source }, locale);
    };

    const generatePointsText = (points?: string, tag?: string) => {
        return t.rich(tag, {
            points: points || '0',
        });
    };

    const handleResult = (res: any) => {
        if (res.code !== '0') return;
        fetchPointtCards(isLogin);
    };

    const handleSlideChange = (swiper: any) => {
        if (num === 0) {
            setTheStyles();
            setNum(1);
        }
        setActiveIndex(swiper.realIndex);
    };

    const handleNext = () => {
        if (swiper && swiper.slideNext) {
            swiper.slideNext();
        }
    };

    const handlePrev = () => {
        if (swiper && swiper.slidePrev) {
            swiper.slidePrev();
        }
    };

    const getInsUrl = (locale: string) => {
        const followUrlMaps: Record<string, string> = {
            us: 'https://www.instagram.com/ecoflowtech/',
            ca: 'https://www.instagram.com/ecoflowtech/',
            eu: 'https://www.instagram.com/ecoflowtech/',
            uk: 'https://www.instagram.com/ecoflowtech/',
            de: 'https://www.instagram.com/ecoflow.deutschland/',
            it: 'https://www.instagram.com/ecoflow.italia/',
            fr: 'https://www.instagram.com/ecoflow.france/',
            es: 'https://www.instagram.com/ecoflow.espana/',
            nl: 'https://www.instagram.com/ecoflow.netherlands/',
            jp: 'https://www.instagram.com/ecoflowjapan/',
            za: 'https://www.instagram.com/ecoflow.southafrica/',
            au: 'https://www.instagram.com/ecoflow.australia/',
            kr: 'https://www.instagram.com/ecoflow_korea/',
            br: 'https://www.instagram.com/ecoflowtech/',
            mx: 'https://www.instagram.com/ecoflow_mexico/',
            ph: 'https://www.instagram.com/ecoflow.sea/',
        };

        return followUrlMaps[locale] || followUrlMaps['us'];
    };

    const refreshTimer = () => {
        setTimeout(() => {
            refershData && refershData();
        }, 1000);
    };

    const cmdFunc: Record<string, () => void> = {
        [PointsBehaviorValue.ATTENTION_INSTAGRAM]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('instagram');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1')}_${t('ins_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Instagram',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1') : ''}_${t(
                    'ins_title',
                )}`,
                button_name: t('ins_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_INSTAGRAM)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    const url = getInsUrl(locale);
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_X]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('x');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1')}_${t('x_title')}_1` : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'X',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1') : ''}_${t('x_title')}_1`,
                button_name: t('x_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_X)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    const url = locale === 'jp' ? 'https://twitter.com/EcoflowJapan/' : 'https://x.com/EcoFlowTech';
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_YOUTUBE]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('youtube');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1')}_${t('youtube_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'YouTube',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1') : ''}_${t(
                    'youtube_title',
                )}`,
                button_name: t('youtube_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_YOUTUBE)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        us: 'https://www.youtube.com/@EcoFlowTech/',
                        ca: 'https://www.youtube.com/@EcoFlowTech/',
                        eu: 'https://www.youtube.com/@EcoFlowTech/',
                        uk: 'https://www.youtube.com/@EcoFlowTech/',
                        de: 'https://www.youtube.com/@EcoFlowDeutschland',
                        jp: 'https://www.youtube.com/channel/UCup-8KjYcdzZf6iP583Q5FQ',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale] || followUrlMaps['us'];
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_FACEBOOK]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('facebook');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1')}_${t('facebook_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Facebook',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1') : ''}_${t(
                    'facebook_title',
                )}`,
                button_name: t('facebook_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_FACEBOOK)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        us: 'https://www.facebook.com/ecoflowtech',
                        ca: 'https://www.facebook.com/ecoflowtech',
                        eu: 'https://www.facebook.com/ecoflowtech',
                        uk: 'https://www.facebook.com/ecoflowtech',
                        de: 'https://www.facebook.com/EcoFlowDeutschland/',
                        it: 'https://www.facebook.com/EcoFlowItalia/',
                        fr: 'https://www.facebook.com/EcoFlowFrance',
                        es: 'https://www.facebook.com/EcoFlowEspana/',
                        nl: 'https://www.facebook.com/EcoFlowNetherlands',
                        jp: 'https://www.facebook.com/EcoFlowJapan/',
                        za: 'https://www.facebook.com/ecoflowaustralia/',
                        au: 'https://www.facebook.com/ecoflowtech',
                        br: 'https://www.facebook.com/EcoFlowLatam',
                        mx: 'https://www.facebook.com/EcoFlowLatam',
                        ph: 'https://www.facebook.com/ecoflowsea#',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale] || followUrlMaps['us'];
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_LINE]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('line');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1')}_${t('line_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1') : ''}_${t('line_title')}`,
                button_name: t('line_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_LINE)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    window.open('https://lin.ee/DkXvQw2', '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_KAKOO]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('kakoo');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1')}_${t('kakoo_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1') : ''}_${t(
                    'kakoo_title',
                )}`,
                button_name: t('kakoo_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_KAKOO)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    window.open('https://pf.kakao.com/_KhFRG', '_blank');
                });
        },
        [PointsBehaviorValue.JOIN_FACEBOOK]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('joinfacebook');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1')}_${t('joininfacebook_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1') : ''}_${t(
                    'joininfacebook_title',
                )}`,
                button_name: t('joininfacebook_title'),
            });
            getPoints(PointsBehaviorValue.JOIN_FACEBOOK)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        eu: 'https://www.facebook.com/groups/ecoflowclub',
                        uk: 'https://bit.ly/UK_FBGroup',
                        de: 'http://bit.ly/3Kis0MT',
                        it: 'https://bit.ly/3QjaD1w',
                        fr: 'http://bit.ly/40uEw1h',
                        es: 'https://www.facebook.com/groups/ecoflowclub',
                        nl: 'https://www.facebook.com/groups/efnetherlands',
                        za: 'https://www.facebook.com/groups/efsouthafrica',
                        br: 'https://www.facebook.com/groups/ecoflowclub',
                        mx: 'https://www.facebook.com/groups/ecoflowclub',
                        ph: 'https://www.facebook.com/ecoflowsea#',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale];
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.COMMUNITY_SEND_CONTENT]: () => {
            if (!isLogin) {
                const newUrl = `${FORUM_DOMAIN}/${locale}/send-post?board=1`;
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.value, 'community_post_desc1')}_${t(
                              'community_post_title',
                          )}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: `${
                    actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.value, 'community_post_desc1') : ''
                }_${t('community_post_title')}`,
                url: `${FORUM_DOMAIN}/${locale}/send-post?board=1`,
            });
            window.open(`${FORUM_DOMAIN}/${locale}/send-post?board=1`, '_blank');
        },
        [PointsBehaviorValue.COMMUNITY_SEND_COMMENT]: () => {
            if (!isLogin) {
                const newUrl = `${FORUM_DOMAIN}/${locale}`;
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.value, 'community_comment_desc1')}_${t(
                              'community_comment_title',
                          )}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: `${
                    actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.value, 'community_comment_desc1') : ''
                }_${t('community_comment_title')}`,
                url: `${FORUM_DOMAIN}/${locale}`,
            });
            window.open(`${FORUM_DOMAIN}/${locale}`, '_blank');
        },
        [PointsBehaviorValue.COMMUNITY_UPVOTE]: () => {
            if (!isLogin) {
                const newUrl = `${FORUM_DOMAIN}/${locale}`;
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_UPVOTE]?.value, 'community_like_desc1')}_${t(
                              'community_like_title',
                          )}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_UPVOTE]?.value, 'community_like_desc1') : ''}_${t(
                    'community_like_title',
                )}`,
                url: `${FORUM_DOMAIN}/${locale}`,
            });
            window.open(`${FORUM_DOMAIN}/${locale}`, '_blank');
        },
    };

    useThrottleEffect(() => {
        if (subEmailCount === 0) return;
        pollingData();
    }, [subEmailCount]);

    useEffect(() => {
        if (actionPoints) {
            const instagram = {
                key: PointsBehaviorValue.ATTENTION_INSTAGRAM,
                title: t('ins_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1'),
                highlighttext: t('ins'),
                icon: <RightIns />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_ins'),
                    button: t('ins_title'),
                    onClick: () => {},
                },
            };

            const x = {
                key: PointsBehaviorValue.ATTENTION_X,
                title: t('x_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1'),
                highlighttext: t('x'),
                icon: <RightX />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_X]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_x'),
                    button: t('x_title'),
                    onClick: () => {},
                },
            };

            const youtube = {
                key: PointsBehaviorValue.ATTENTION_YOUTUBE,
                title: t('youtube_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1'),
                highlighttext: t('youtube'),
                icon: <RightYoutube />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_youtube'),
                    button: t('youtube_title'),
                    onClick: () => {},
                },
            };

            const facebook = {
                key: PointsBehaviorValue.ATTENTION_FACEBOOK,
                title: t('facebook_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1'),
                highlighttext: t('facebook'),
                icon: <RightFacebook />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc2'),
                    // button: t('follow_button'),
                    button: t('facebook_title'),
                    onClick: () => {},
                },
            };

            const line = {
                key: PointsBehaviorValue.ATTENTION_LINE,
                title: t('line_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1'),
                highlighttext: t('line'),
                icon: <RightFollow />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc2'),
                    // button: t('follow_button2'),
                    button: t('line_title'),
                    onClick: () => {},
                },
            };

            const kakoo = {
                key: PointsBehaviorValue.ATTENTION_KAKOO,
                title: t('kakoo_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1'),
                highlighttext: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1'),
                icon: <RightKakoo />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc2'),
                    // button: t('follow_button'),
                    button: t('kakoo_title'),
                    onClick: () => {},
                },
            };

            const joininfacebook = {
                key: PointsBehaviorValue.JOIN_FACEBOOK,
                title: t('joininfacebook_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1'),
                highlighttext: t('joininfacebook'),

                icon: <RightFacebook />,
                isFinish: !!actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc2'),
                    button: t('joininfacebook_title'),
                    onClick: () => {},
                },
            };

            const communityPost = {
                key: PointsBehaviorValue.COMMUNITY_SEND_CONTENT,
                title: t('community_post_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.value, 'community_post_desc1'),
                highlighttext: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.value, 'community_post_desc1'),
                icon: <RightCommunityPost />,
                isFinish: !!actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]?.value, 'community_post_desc2'),
                    button: t('community_post_btn'),
                    onClick: () => {},
                },
            };

            const communityComment = {
                key: PointsBehaviorValue.COMMUNITY_SEND_COMMENT,
                title: t('community_comment_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.value, 'community_comment_desc1'),
                highlighttext: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.value, 'community_comment_desc1'),
                icon: <RightCommunityComment />,
                isFinish: !!actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]?.value, 'community_comment_desc2'),
                    button: t('community_comment_btn'),
                    onClick: () => {},
                },
            };

            const communityLike = {
                key: PointsBehaviorValue.COMMUNITY_UPVOTE,
                title: t('community_like_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_UPVOTE]?.value, 'community_like_desc1'),
                highlighttext: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_UPVOTE]?.value, 'community_like_desc1'),
                icon: <RightCommunityLike />,
                isFinish: true,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.COMMUNITY_UPVOTE]?.value, 'community_like_desc2'),
                    button: t('community_like_btn'),
                    onClick: () => {},
                },
            };

            const actionsSet = [communityPost, communityComment, communityLike, instagram, x, youtube, facebook, line, kakoo, joininfacebook];
            const finalData = actionsSet.filter((item) => actionPoints[item.key]);

            const communityItems = finalData.filter(
                (item) =>
                    item.key === PointsBehaviorValue.COMMUNITY_SEND_CONTENT ||
                    item.key === PointsBehaviorValue.COMMUNITY_SEND_COMMENT ||
                    item.key === PointsBehaviorValue.COMMUNITY_UPVOTE,
            );
            const otherItems = finalData.filter(
                (item) =>
                    item.key !== PointsBehaviorValue.COMMUNITY_SEND_CONTENT &&
                    item.key !== PointsBehaviorValue.COMMUNITY_SEND_COMMENT &&
                    item.key !== PointsBehaviorValue.COMMUNITY_UPVOTE,
            );

            const warrantyIndex = defaultData.findIndex((item) => item.key === 'warranty');
            const mergedData = [
                ...defaultData.slice(0, warrantyIndex + 1), // warranty 之前（包括 warranty）
                ...communityItems, // 社区三兄弟
                ...defaultData.slice(warrantyIndex + 1), // warranty 之后（profile 等）
                ...otherItems, // 其他社交媒体
            ];

            const [c1] = dataForSlide(mergedData);
            console.log({ finalData, communityItems, otherItems, mergedData });
            if (c1) {
                c1.forEach((element) => {
                    const isBelong = actionsSet.find((item) => item.key === element.key);
                    if (isBelong) {
                        element.uncomplate.onClick = () => cmdFunc[PointsBehaviorValue[element.key]]();
                    }
                });
            }
            const slideDataRes = dataForSlide(mergedData);
            console.log({ slideDataRes });
            setSlideData(slideDataRes);
        }
    }, [actionPoints]);

    useEffect(() => {
        const type = router?.query[newWayType];

        // 点击对应行为，登录返回后若没完成积分任务进行对应操作
        if (type) {
            if (type === 'subscribe') {
                !subscribeIsFinish && setSubscribeModalOpen(true);
            } else if (type === 'warranty') {
                !warrantyIsFinish && router.push(`/${locale}/support/warranty`);
            } else if (type === 'profile') {
                !profileIsFinish && router.push(`/${locale}/my-overview`);
            } else if (type === 'instagram') {
                if (!instagramIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_INSTAGRAM]();
                    }, 500);
                }
            } else if (type === 'x') {
                if (!xIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_X]();
                    }, 500);
                }
            } else if (type === 'youtube') {
                if (!youtubeIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_YOUTUBE]();
                    }, 500);
                }
            } else if (type === 'facebook') {
                if (!facebookIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_FACEBOOK]();
                    }, 500);
                }
            } else if (type === 'joinfacebook') {
                if (!jFackbookIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.JOIN_FACEBOOK]();
                    }, 500);
                }
            } else if (type === 'line') {
                if (!lineIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_LINE]();
                    }, 500);
                }
            } else if (type === 'kakoo') {
                if (!kakooIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_KAKOO]();
                    }, 500);
                }
            } else if (type === 'communitypost') {
                if (!communityPostIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.COMMUNITY_SEND_CONTENT]();
                    }, 500);
                }
            } else if (type === 'communitycomment') {
                if (!communityCommentIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.COMMUNITY_SEND_COMMENT]();
                    }, 500);
                }
            } else if (type === 'communitylike') {
                if (!communityLikeIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.COMMUNITY_UPVOTE]();
                    }, 500);
                }
            }
            removeQueryParam();
        }
    }, [
        subscribeIsFinish,
        warrantyIsFinish,
        profileIsFinish,
        instagramIsFinish,
        xIsFinish,
        youtubeIsFinish,
        facebookIsFinish,
        jFackbookIsFinish,
        lineIsFinish,
        kakooIsFinish,
        communityPostIsFinish,
        communityCommentIsFinish,
        communityLikeIsFinish,
        router,
        locale,
    ]);

    const initSwiper = () => {
        // 动态修改按钮的字号的padding,de的文案太长，运营还不肯换文案，没办法，嗐~
        // 延迟一秒，不然获取不到第二页的元素
        setTimeout(() => {
            setTheStyles();
        }, 50);
    };

    const setTheStyles = () => {
        if (isMobile) {
            const btnList = document.querySelectorAll('.ecocredits-points-wrapper .item .wtee-btn');

            const itemWrap: any = document.querySelector('.ecocredits-points-wrapper .item');
            if (itemWrap) {
                const wrapWidth = itemWrap.offsetWidth;
                if (btnList && btnList?.length > 0) {
                    btnList.forEach((ele: any) => {
                        const btnWidth = ele?.getBoundingClientRect()?.width || 0;
                        const btnHeight = ele?.getBoundingClientRect()?.height || 0;
                        // 假设按钮高度太高，超过3行，也修改一下
                        if (btnWidth >= wrapWidth || btnHeight > 50) {
                            ele.style.fontSize = '8px';
                            ele.style.padding = '4px 6px';
                        }
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }

        const handleResize = () => {
            setIsPadWidth(getIsPadWidth());
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <div
                className={`${css.ways_to_earn_points} GtmModuleData-section 79`}
                data-section-id={'Member-WaysToEarnPoints'}
                data-section-title={t('earn_points_title')}
                id={pageId}
            >
                <div className="wtep-wrapper">
                    <h5 className="title">
                        {t('earn_points_title')}
                        <Link href={`https://${locale}.ecoflow.com/pages/rewards-guide`}>
                            <EFQuestionMark2 />
                        </Link>
                    </h5>
                    <div className="swiper-wrapper ecocredits-points-wrapper">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            className="card-swiper"
                            pagination={{
                                clickable: true,
                            }}
                            slidesPerView={1}
                            initialSlide={0}
                            spaceBetween={0}
                            centeredSlides={true}
                            navigation={true}
                            onSlideChange={handleSlideChange}
                            onSwiper={(swiperIns) => setSwiper(swiperIns)}
                            onInit={initSwiper}
                        >
                            {slideData?.map((card: any, k: number) => (
                                <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                    <ul className="list">
                                        {card.map((item: any, k2: number) => {
                                            return (
                                                <li key={item.key} className={`ways-item item-li-${k2} ${!!statusMap[item.key] && 'right'}`}>
                                                    <div className="basic">
                                                        {!statusMap[item.key] ? (
                                                            <>
                                                                <div className="icon">{item.icon}</div>
                                                                <div className="content">
                                                                    <p className="item-text">{item.text}</p>
                                                                    {k > 0 ? (
                                                                        <Button className="wtee-btn" onClick={cmdFunc[item.key]}>
                                                                            {item?.uncomplate?.button}&nbsp;{`>>`}
                                                                        </Button>
                                                                    ) : (
                                                                        <Button
                                                                            className="wtee-btn"
                                                                            onClick={() => item?.uncomplate?.onClick && item.uncomplate.onClick()}
                                                                        >
                                                                            {item?.uncomplate?.button}&nbsp;{`>>`}
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                                <div className="bottom-icon">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="100%"
                                                                        height="100%"
                                                                        viewBox="0 0 52 40"
                                                                        fill="none"
                                                                    >
                                                                        <g filter="url(#filter0_i_5020_22310)">
                                                                            <path
                                                                                d="M52.417 45.2041C52.4162 49.5819 45.8249 51.8729 39.3125 51.873C32.8001 51.8729 26.2098 49.5819 26.209 45.2041V41.8691C26.2094 46.2471 32.8 48.538 39.3125 48.5381C45.825 48.538 52.4165 46.2471 52.417 41.8691V45.2041ZM52.417 38.5342C52.4166 42.9122 45.825 45.203 39.3125 45.2031C32.8 45.203 26.2094 42.9122 26.209 38.5342V35.1992C26.2094 39.5772 32.8 41.869 39.3125 41.8691C45.825 41.869 52.4166 39.5772 52.417 35.1992V38.5342ZM0 31.123C0.000157517 36.9608 8.94533 40.0156 17.7842 40.0156C18.7519 40.0156 19.7213 39.9762 20.6797 39.9033L20.4854 44.3643C19.5904 44.4277 18.6866 44.4619 17.7842 44.4619C8.94533 44.4619 0.000157522 41.4071 0 35.5693V31.123ZM52.417 31.8643C52.4166 36.2423 45.825 38.5341 39.3125 38.5342C32.8 38.5341 26.2094 36.2423 26.209 31.8643V28.5303C26.2098 32.908 32.8002 35.1991 39.3125 35.1992C45.8248 35.1991 52.4162 32.908 52.417 28.5303V31.8643ZM0 22.2305C0.000157517 28.0682 8.94533 31.123 17.7842 31.123C18.8826 31.123 19.9831 31.0753 21.0674 30.9814L20.873 35.4424C19.8517 35.5254 18.8171 35.5693 17.7842 35.5693C8.94533 35.5693 0.000157522 32.5145 0 26.6768V22.2305ZM39.3125 18.5264C45.825 18.5265 52.4166 20.8173 52.417 25.1953C52.4166 29.5733 45.825 31.8651 39.3125 31.8652C32.8 31.8651 26.2094 29.5733 26.209 25.1953C26.2094 20.8173 32.7999 18.5265 39.3125 18.5264ZM0 13.3379C0.000157517 19.1756 8.94533 22.2305 17.7842 22.2305C19.0138 22.2304 20.2457 22.1683 21.4551 22.0508L21.2607 26.5166C20.1139 26.6219 18.948 26.6767 17.7842 26.6768C8.94533 26.6768 0.000157522 23.6219 0 17.7842V13.3379ZM17.7842 0C26.6227 0.000250998 35.5684 3.05497 35.5684 8.89258C35.5679 14.7299 26.6225 17.7849 17.7842 17.7852C8.94546 17.7852 0.000420382 14.7302 0 8.89258C0 3.05473 8.94526 0 17.7842 0Z"
                                                                                fill="url(#paint0_linear_5020_22310)"
                                                                            />
                                                                        </g>
                                                                        <g filter="url(#filter1_i_5020_22310)">
                                                                            <path
                                                                                d="M9.18652 4.25085H16.2798M9.18652 11.9578H16.2798M19.5536 4.25085H26.6469M9.18652 8.20849H16.2798M19.5536 12.2256V8.7319C19.5536 8.44283 19.7979 8.20849 20.0993 8.20849H26.6469"
                                                                                stroke="url(#paint1_linear_5020_22310)"
                                                                                strokeWidth="1.45"
                                                                                strokeLinecap="round"
                                                                            />
                                                                        </g>
                                                                        <defs>
                                                                            <filter
                                                                                id="filter0_i_5020_22310"
                                                                                x="0"
                                                                                y="0"
                                                                                width="52.7054"
                                                                                height="51.873"
                                                                                filterUnits="userSpaceOnUse"
                                                                                colorInterpolationFilters="sRGB"
                                                                            >
                                                                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                                                <feBlend
                                                                                    mode="normal"
                                                                                    in="SourceGraphic"
                                                                                    in2="BackgroundImageFix"
                                                                                    result="shape"
                                                                                />
                                                                                <feColorMatrix
                                                                                    in="SourceAlpha"
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                                    result="hardAlpha"
                                                                                />
                                                                                <feOffset dx="0.28843" />
                                                                                <feGaussianBlur stdDeviation="0.35" />
                                                                                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                                                                <feColorMatrix
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0.291617 0 0 0 0 0.291617 0 0 0 0 0.291617 0 0 0 0.32 0"
                                                                                />
                                                                                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5020_22310" />
                                                                            </filter>
                                                                            <filter
                                                                                id="filter1_i_5020_22310"
                                                                                x="8.46191"
                                                                                y="3.3141"
                                                                                width="19.2278"
                                                                                height="9.63659"
                                                                                filterUnits="userSpaceOnUse"
                                                                                colorInterpolationFilters="sRGB"
                                                                            >
                                                                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                                                <feBlend
                                                                                    mode="normal"
                                                                                    in="SourceGraphic"
                                                                                    in2="BackgroundImageFix"
                                                                                    result="shape"
                                                                                />
                                                                                <feColorMatrix
                                                                                    in="SourceAlpha"
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                                    result="hardAlpha"
                                                                                />
                                                                                <feOffset dx="0.317673" dy="-0.211782" />
                                                                                <feGaussianBlur stdDeviation="0.158836" />
                                                                                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                                                                <feColorMatrix
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0.289748 0 0 0 0 0.276894 0 0 0 0 0.230422 0 0 0 0.25 0"
                                                                                />
                                                                                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5020_22310" />
                                                                            </filter>
                                                                            <linearGradient
                                                                                id="paint0_linear_5020_22310"
                                                                                x1="15.5442"
                                                                                y1="51.1384"
                                                                                x2="51.9544"
                                                                                y2="21.0655"
                                                                                gradientUnits="userSpaceOnUse"
                                                                            >
                                                                                <stop offset="0.0144231" stopColor="#E5E5E5" />
                                                                                <stop offset="0.397281" stopColor="#EFEFEF" />
                                                                                <stop offset="1" stopColor="#DCDCDC" />
                                                                            </linearGradient>
                                                                            <linearGradient
                                                                                id="paint1_linear_5020_22310"
                                                                                x1="8.21612"
                                                                                y1="12.2256"
                                                                                x2="19.0108"
                                                                                y2="0.649521"
                                                                                gradientUnits="userSpaceOnUse"
                                                                            >
                                                                                <stop offset="0.0144231" stopColor="#E3E3E3" />
                                                                                <stop offset="0.480277" stopColor="#DEDEDE" />
                                                                                <stop offset="0.951923" stopColor="#CDCDCD" />
                                                                            </linearGradient>
                                                                        </defs>
                                                                    </svg>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="icon right">
                                                                    <RightIcon />
                                                                </div>
                                                                <div className="content">
                                                                    <h5 className="item-right-title">{item.title}</h5>
                                                                    <p className="item-right-text">{item.highlighttext}</p>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="swipwe-btn-container">
                            <button className={`swiper-button-prev swipwe-btn ${activeIndex === 0 ? 'disabled' : ''}`} onClick={handlePrev}></button>
                            <button
                                className={`swiper-button-next swipwe-btn ${activeIndex === slideData.length - 1 ? 'disabled' : ''}`}
                                onClick={handleNext}
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <EfModal className={css.efmodal} visible={profileModalOpen} onCancel={() => setProfileModalOpen(false)} zIndex={1200}>
                <div className="note-content">
                    <h4 className="rule-title">{t('profile_a')}</h4>
                    <p className="rule-desc">{t('profile_detail')}</p>
                </div>
            </EfModal>

            <SubscribeModal open={subscribeModalOpen} closeModal={() => setSubscribeModalOpen(false)} onSuccess={() => pollingData()} />

            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}

            {isClient &&
                showLoginModal1 &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal1}
                        onCancel={() => {
                            setShowLoginModal1(false);
                        }}
                        type="passwordless"
                        isRegister={true}
                    />,
                    document.body,
                )}
        </>
    );
};

export default WaysToEarnPoints;
